"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * InodePilot documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 4.4.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionControllerApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class ActionControllerApi extends runtime.BaseAPI {
    /**
     * Finds one Actions
     */
    getActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null ||
                requestParameters.id === undefined) {
                throw new runtime.RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getAction.");
            }
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling getAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     * Finds one Actions
     */
    getAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getActionInterpretationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null ||
                requestParameters.id === undefined) {
                throw new runtime.RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getActionInterpretations.");
            }
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling getActionInterpretations.");
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/{id}/interpretations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.InterpretationFromJSON));
        });
    }
    /**
     */
    getActionInterpretations(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getActionInterpretationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getActionOperatorInvocationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null ||
                requestParameters.id === undefined) {
                throw new runtime.RequiredError("id", "Required parameter requestParameters.id was null or undefined when calling getActionOperatorInvocations.");
            }
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling getActionOperatorInvocations.");
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/{id}/operatorInvocations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.OperatorInvocationFromJSON));
        });
    }
    /**
     */
    getActionOperatorInvocations(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getActionOperatorInvocationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Retrieves all actions
     * Finds all Actions
     */
    listActionsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling listActions.");
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.ActionFromJSON));
        });
    }
    /**
     * Retrieves all actions
     * Finds all Actions
     */
    listActions(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listActionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    putFilterByRangeActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling putFilterByRangeAction.");
            }
            if (requestParameters.FilterByRangeRequestBody === null ||
                requestParameters.FilterByRangeRequestBody === undefined) {
                throw new runtime.RequiredError("FilterByRangeRequestBody", "Required parameter requestParameters.FilterByRangeRequestBody was null or undefined when calling putFilterByRangeAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/filter-by-range`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.FilterByRangeRequestBodyToJSON)(requestParameters.FilterByRangeRequestBody),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     */
    putFilterByRangeAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putFilterByRangeActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    putLogActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.LoggingRequest === null ||
                requestParameters.LoggingRequest === undefined) {
                throw new runtime.RequiredError("LoggingRequest", "Required parameter requestParameters.LoggingRequest was null or undefined when calling putLogAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            const response = yield this.request({
                path: `/v2/actions/log`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.LoggingRequestToJSON)(requestParameters.LoggingRequest),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    putLogAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.putLogActionRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Invoke a nl2sparql translation action
     */
    putNl2sparqlActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling putNl2sparqlAction.");
            }
            if (requestParameters.Nl2SparqlRequestBody === null ||
                requestParameters.Nl2SparqlRequestBody === undefined) {
                throw new runtime.RequiredError("Nl2SparqlRequestBody", "Required parameter requestParameters.Nl2SparqlRequestBody was null or undefined when calling putNl2sparqlAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/nl2sparql`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.Nl2SparqlRequestBodyToJSON)(requestParameters.Nl2SparqlRequestBody),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     * Invoke a nl2sparql translation action
     */
    putNl2sparqlAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putNl2sparqlActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Invoke a nl2sql translation action
     */
    putNl2sqlActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling putNl2sqlAction.");
            }
            if (requestParameters.Nl2SqlRequestBody === null ||
                requestParameters.Nl2SqlRequestBody === undefined) {
                throw new runtime.RequiredError("Nl2SqlRequestBody", "Required parameter requestParameters.Nl2SqlRequestBody was null or undefined when calling putNl2sqlAction.");
            }
            const queryParameters = {};
            if (requestParameters.maxInterpretations !== undefined) {
                queryParameters["maxInterpretations"] =
                    requestParameters.maxInterpretations;
            }
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/nl2sql`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.Nl2SqlRequestBodyToJSON)(requestParameters.Nl2SqlRequestBody),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     * Invoke a nl2sql translation action
     */
    putNl2sqlAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putNl2sqlActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    putPipelineFacetActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling putPipelineFacetAction.");
            }
            if (requestParameters.ByFacetRequest === null ||
                requestParameters.ByFacetRequest === undefined) {
                throw new runtime.RequiredError("ByFacetRequest", "Required parameter requestParameters.ByFacetRequest was null or undefined when calling putPipelineFacetAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/facet`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.ByFacetRequestToJSON)(requestParameters.ByFacetRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     */
    putPipelineFacetAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putPipelineFacetActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Invoke a filtering action
     */
    putPipelineFilterActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling putPipelineFilterAction.");
            }
            if (requestParameters.ByFilterRequest === null ||
                requestParameters.ByFilterRequest === undefined) {
                throw new runtime.RequiredError("ByFilterRequest", "Required parameter requestParameters.ByFilterRequest was null or undefined when calling putPipelineFilterAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/filter`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.ByFilterRequestToJSON)(requestParameters.ByFilterRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     * Invoke a filtering action
     */
    putPipelineFilterAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putPipelineFilterActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    putPipelineSupersetActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling putPipelineSupersetAction.");
            }
            if (requestParameters.BySupersetRequest === null ||
                requestParameters.BySupersetRequest === undefined) {
                throw new runtime.RequiredError("BySupersetRequest", "Required parameter requestParameters.BySupersetRequest was null or undefined when calling putPipelineSupersetAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/superset`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.BySupersetRequestToJSON)(requestParameters.BySupersetRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     */
    putPipelineSupersetAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putPipelineSupersetActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Invoke a materialization of a structured query to data
     */
    putQl2dataActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling putQl2dataAction.");
            }
            if (requestParameters.Nl2SqlRequestBody === null ||
                requestParameters.Nl2SqlRequestBody === undefined) {
                throw new runtime.RequiredError("Nl2SqlRequestBody", "Required parameter requestParameters.Nl2SqlRequestBody was null or undefined when calling putQl2dataAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/ql2data`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.Nl2SqlRequestBodyToJSON)(requestParameters.Nl2SqlRequestBody),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     * Invoke a materialization of a structured query to data
     */
    putQl2dataAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putQl2dataActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    putRecommendationsActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling putRecommendationsAction.");
            }
            if (requestParameters.ByRecommendationRequestBody === null ||
                requestParameters.ByRecommendationRequestBody === undefined) {
                throw new runtime.RequiredError("ByRecommendationRequestBody", "Required parameter requestParameters.ByRecommendationRequestBody was null or undefined when calling putRecommendationsAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/recommendations`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.ByRecommendationRequestBodyToJSON)(requestParameters.ByRecommendationRequestBody),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     */
    putRecommendationsAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putRecommendationsActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Invoke a materialization of a structured sql query to data
     */
    putSql2dataActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling putSql2dataAction.");
            }
            if (requestParameters.Nl2SqlRequestBody === null ||
                requestParameters.Nl2SqlRequestBody === undefined) {
                throw new runtime.RequiredError("Nl2SqlRequestBody", "Required parameter requestParameters.Nl2SqlRequestBody was null or undefined when calling putSql2dataAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters["Content-Type"] = "application/json";
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/sql2data`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.Nl2SqlRequestBodyToJSON)(requestParameters.Nl2SqlRequestBody),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     * Invoke a materialization of a structured sql query to data
     */
    putSql2dataAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putSql2dataActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    putSql2nlActionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.X_Reference_ID === null ||
                requestParameters.X_Reference_ID === undefined) {
                throw new runtime.RequiredError("X_Reference_ID", "Required parameter requestParameters.X_Reference_ID was null or undefined when calling putSql2nlAction.");
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.X_Reference_ID !== undefined &&
                requestParameters.X_Reference_ID !== null) {
                headerParameters["X-Reference-ID"] = String(requestParameters.X_Reference_ID);
            }
            const response = yield this.request({
                path: `/v2/actions/sql2nl`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ActionFromJSON)(jsonValue));
        });
    }
    /**
     */
    putSql2nlAction(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putSql2nlActionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.ActionControllerApi = ActionControllerApi;
